import { Booking } from '@contact/upgrade';

import { SocialNetworkMessage } from './social-network-message';
import { SocialNetworkModel } from './social-network-model';

export class SocialNetworkTab {
  public newMessagesCount: number;
  public lastMessageTime: number;
  public closedByClient: boolean;
  private _socialNetworkName: string;

  private _firstMessageTime: number;
  private _lastMessage: string;
  private _isLastMessageFromClient: boolean;

  private type: string;

  constructor(socialNetworkName: string, lastMessage: string) {
    this._socialNetworkName = socialNetworkName;
    this.newMessagesCount = 0;
    this._lastMessage = lastMessage;
    this.lastMessageTime = Number.MIN_VALUE;
    this._firstMessageTime = Number.MAX_VALUE;
    this.closedByClient = false;
    this._isLastMessageFromClient = false;
  }

  get getNewConversationCount(): number {
    return this.newMessagesCount;
  }

  get getType(): string {
    return this.type;
  }

  get firstMessageTime(): number {
    return this._firstMessageTime;
  }

  get lastMessage(): string {
    return this._lastMessage;
  }

  get isLastMessageFromClient(): boolean {
    return this._isLastMessageFromClient;
  }

  get socialNetworkName(): string {
    return this._socialNetworkName;
  }

  static fromSocialNetwork(socialNetworkModel: SocialNetworkModel, contact: Booking): SocialNetworkTab {
    let socialNetworkName: string = '';
    let lastMessageFromClient: string = '';
    if (contact.customerName != null && contact.customerName !== 'agent:contact.info.unknown_contact') {
      socialNetworkName = contact.customerName;
    } else {
      if (socialNetworkModel.messages.length > 0) {
        socialNetworkName = SocialNetworkTab.computeSocialNetworkName(socialNetworkModel.messages[0]);
        lastMessageFromClient = socialNetworkModel.messages[0].content;
      }
    }
    const socialNetworkTab = new SocialNetworkTab(socialNetworkName, lastMessageFromClient);

    // Update last message and elapsedTime
    socialNetworkModel.messages.forEach(m => {
      socialNetworkTab.updateSocialNetworkTabInfo(m);
    });

    if (!!contact.context['dimelo_type']) {
      socialNetworkTab.type = contact.context['dimelo_type'];
    }

    return socialNetworkTab;
  }

  static computeSocialNetworkName(msg: SocialNetworkMessage): string {
    if (!!msg.firstName && !!msg.lastName) {
      return `${msg.firstName} ${msg.lastName}`;
    }
    return '';
  }

  hasNewMessage(): boolean {
    return this.newMessagesCount > 0;
  }

  increaseUnreadCount() {
    this.newMessagesCount++;
  }

  resetUnreadCount() {
    this.newMessagesCount = 0;
  }

  updateNameContact(name: string) {
    this._socialNetworkName = name;
  }

  updateSocialNetworkTabInfo(message: SocialNetworkMessage) {
    this.lastMessageTime = message.date || 0;
    this._lastMessage = message.content;
    if (message.date && message.date < this._firstMessageTime) {
      this._firstMessageTime = message.date || 0;
    }
  }
}
